import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "background"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!

  return (_ctx.display)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "bgclick",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
        }),
        _createElementVNode("section", {
          class: _normalizeClass(["modal", `size_${_ctx.size}`])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["content", { nopadding: _ctx.padding == 'none' }])
          }, [
            _createElementVNode("div", {
              class: "close",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleModal && _ctx.toggleModal(...args)))
            }, [
              _createVNode(_component_ic, { icon: "times" })
            ]),
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ], 2)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}